import styled from 'styled-components';

export const Form = styled('form')({
  display: 'flex',
  gap: '16px',
  flexDirection: 'column',
});
